var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resource-form',{attrs:{"id":_vm.id,"type":"case_study","plural":"case_studies","title":"Case study"},model:{value:(_vm.case_study),callback:function ($$v) {_vm.case_study=$$v},expression:"case_study"}})}
var staticRenderFns = []

export { render, staticRenderFns }